import { Type } from '@sinclair/typebox';
export const getStripeSessionStatusQuerySchema = Type.Object({
    session_id: Type.String(),
});
export const getStripeSessionStatusResponseSchema = Type.Object({
    status: Type.Union([Type.String(), Type.Null()]),
    payment_status: Type.Union([Type.Literal('no_payment_required'), Type.Literal('paid'), Type.Literal('unpaid')]),
    customer_details: Type.Object({
        email: Type.Union([Type.String(), Type.Null()]),
    }),
});
export const createCheckoutSessionRequestSchema = Type.Object({
    formData: Type.Object({
        orderData: Type.Object({
            currency: Type.String(),
            products: Type.Array(Type.Object({
                quantity: Type.Number(),
                amount: Type.Number(),
                name: Type.String(),
            })),
        }),
    }),
});
export const createCheckoutSessionResponseSchema = Type.Object({
    id: Type.String(),
    clientSecret: Type.Union([Type.String(), Type.Null()]),
});
export const orderFromStripePaymentIntentResponseSchema = Type.Object({
    orderId: Type.String(),
});
export const orderFromStripePaymentIntentResponseSchemaV2 = Type.Union([
    Type.Object({
        status: Type.Literal('orderCreated'),
        orderId: Type.String(),
    }),
    Type.Object({
        status: Type.Literal('chargeFailed'),
        error: Type.Object({
            message: Type.String(),
            code: Type.Optional(Type.String()),
        }),
    }),
]);
export const confirmPaymentIntentRequestSchema = Type.Object({
    confirmationTokenId: Type.String(),
    paymentIntentId: Type.String(),
});
export const confirmPaymentIntentResponseSchema = Type.Object({
    clientSecret: Type.String(),
    status: Type.Union([
        Type.Literal('succeeded'),
        Type.Literal('requires_payment_method'),
        Type.Literal('requires_confirmation'),
        Type.Literal('requires_action'),
        Type.Literal('processing'),
        Type.Literal('canceled'),
        Type.Literal('requires_capture'),
    ]),
});
export const confirmPaymentIntentResponseSchemaV2 = Type.Union([
    Type.Object({
        status: Type.Literal('confirmed'),
        paymentIntentClientSecret: Type.String(),
        paymentIntentStatus: Type.Union([
            Type.Literal('succeeded'),
            Type.Literal('requires_payment_method'),
            Type.Literal('requires_confirmation'),
            Type.Literal('requires_action'),
            Type.Literal('processing'),
            Type.Literal('canceled'),
            Type.Literal('requires_capture'),
        ]),
    }),
    Type.Object({
        status: Type.Literal('failed'),
        error: Type.Object({
            message: Type.String(),
            code: Type.Optional(Type.String()),
        }),
    }),
]);
//# sourceMappingURL=schema.js.map